import { FilesContract } from '../../types/Endpoints/files/FilesContract';
import { request } from '../../helpers/api/request';

export const uploadFile = async (file: FormData) => {
    const { data } = await request<FilesContract>({
        url: 'files',
        headers: {
            'Content-Type': 'multipart/form-data;',
        },
        method: 'POST',
        data: file,
    });

    return data;
};
